import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-0 lg:px-18 md:mt-0 -mt-12" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row gap-4 lg:gap-6 relative" }
const _hoisted_3 = { class: "grid grid-cols-12 gap-6 w-full aspect-video lg:absolute lg:-right-18 items-start -z-10" }
const _hoisted_4 = { class: "grid grid-cols-5 gap-4 smm:grid-cols-7 lg:grid-cols-12 lg:gap-6 w-full lg:aspect-[2] lg:items-center relative -mt-10 lg:mt-0 lg:pt-44 px-4 md:px-0" }
const _hoisted_5 = { class: "col-span-full smm:col-span-5 smm:col-start-2 lg:col-start-1 lg:col-span-3 flex flex-col gap-2 2xl:gap-4 text-mono-white text-center items-center" }
const _hoisted_6 = { class: "title text-2xl lg:text-xl xl:text-3xl font-bold" }
const _hoisted_7 = { class: "flex flex-row flex-nowrap gap-6 justify-center items-center" }
const _hoisted_8 = {
  key: 0,
  class: "air-time font-bold text-xl"
}
const _hoisted_9 = { class: "btn-wrapper flex flex-col md:flex-row lg:flex-col w-full gap-4 items-center" }
const _hoisted_10 = {
  key: 0,
  class: "text-center text-mono-white min-w-fit w-full"
}
const _hoisted_11 = {
  key: 1,
  class: "text-center btn rounded-2.4xl xl:rounded-3xl border border-sa-dark text-mono-white min-w-fit w-full"
}
const _hoisted_12 = {
  key: 2,
  class: "text-center btn rounded-2.4xl xl:rounded-3xl border border-sd-dark text-mono-white min-w-fit w-full"
}
const _hoisted_13 = {
  key: 3,
  class: "text-center btn rounded-2.4xl xl:rounded-3xl border border-sd-dark text-mono-white min-w-fit w-full"
}
const _hoisted_14 = {
  key: 4,
  class: "text-center btn rounded-2.4xl xl:rounded-3xl border border-sa-dark text-mono-white min-w-fit w-full"
}
const _hoisted_15 = {
  key: 3,
  id: "replay-info",
  class: "text-xs"
}
const _hoisted_16 = { class: "flex flex-row justify-center gap-4 text-xs" }
const _hoisted_17 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_18 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_19 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_20 = {
  key: 0,
  class: "font-bold"
}

import {useStore} from "../store";
import PictureComponent from "./PictureComponent.vue";
import ActionButtonComponent from "./ActionButtonComponent.vue";
import CountdownComponent from "./CountdownComponent.vue";
import {computed, ref, watch} from "vue";
import dayjs from "dayjs";

import {formatPrice, openWindow, formatDuration} from "../utils";
import TrailerComponent from "./TrailerComponent.vue";
import {useContentStore} from "../store/content";
import PillOnAir from "./PillOnAir.vue";
import getCast from "../../../lib/chromecast";
// import relativeTime from 'dayjs/plugin/relativeTime';
// dayjs.extend(relativeTime)

type ActionButtonProps = {
    label: string, // display text
    icon: string, // action to perform
    styleType: string, // display style
    spinner: boolean, // show spinner
    onclick: () => void | boolean, // callback
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsScreen',
  emits: ["toggle"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const contentItem = useContentStore();
const trailerVisible = ref(false)
const trailerPause = ref(false)
const trailerMute = ref(true)
let acted = false;
let cast = null;


watch(() => store.itemLoaded, (itemLoaded) => {
    // console.log('itemLoaded', itemLoaded);
    if (!itemLoaded)
        return;
    handleCast()
})

const onCastConnected = (e) => {
    if (!cast)
        return;
    if (e?.detail?.active && parseInt(cast.contentId()) === contentItem.id) {
        store.setCastActive()
    }
    cast.off("connected", onCastConnected)
}

function handleCast(){
    if (contentItem.tags.includes("authorized")){
        const castOpts = {}
        if (contentItem.tags.includes("dev")){
            castOpts["receiver"] = '159A62D0'
        }
        cast = getCast(castOpts);
        cast.on("connected", onCastConnected)
    }
}

const startTimeStr = computed(() => {
    const airTime = contentItem.broadcasts?.filter(row => {
        return row.is_live === true
    }).pop()

    if (airTime){
        let formater = "MMM DD | h:mm A"
        if (new Date().getFullYear() > new Date(airTime.air_start_time).getFullYear()) {
            formater = "MMM DD, YYYY"
        }
        return dayjs(airTime.air_start_time).format(formater)
    }else{
        return ''
    }
})

const countdownTo = computed(() => {
    const airTime = contentItem.broadcasts?.filter(row => {
        return row.is_live === true
    }).pop()
    if (!airTime || (new Date(airTime.air_start_time) < new Date(store.itemVersion))){
        return ""
    }
    return airTime.air_start_time
})

function getHistoryRecord(id: number) {
    if (!window.localStorage)
        return null
    const key = "fite.pbp";
    const rawRecord = localStorage.getItem(key);
    if (!rawRecord)
        return null;
    const record = JSON.parse(rawRecord);
    if (!record){
        return null;
    }
    for (var i = 0; i < record.data.length; i++){
        if (record.data[i].video_id === id){
            return record.data[i];
        }
    }
    return null;
}

const links = computed(() : ActionButtonProps[] => {
    const airTime = contentItem.broadcasts?.filter(row => {
        return row.is_live === true
    }).pop()
    const vodTime = contentItem.broadcasts?.filter(row => {
        return row.is_live === false // || row?.is_live === undefined
    }).pop()

    if (!store.itemLoaded ||
        contentItem.tags.includes("restricted") ||
        contentItem.tags.includes("expired")
    ){
        // console.log(
        //     "loaded:", store.itemLoaded,
        //     "restricted:", contentItem.tags.includes("restricted"),
        //     "expired:", contentItem.tags.includes("expired"),
        //     "upcoming:", (airTime && new Date(airTime.air_start_time) > new Date(store.itemVersion)))
        return []
    }

    if ((!contentItem.billing && contentItem.tags.includes("authorized")) || contentItem.billing?.is_purchased){
        const nowDt = new Date(store.itemVersion)

        // (upcoming, no buttons), (after vod end), (between live and vod)
        if((airTime && nowDt < new Date(airTime.air_start_time))
            || (vodTime && nowDt > new Date(vodTime.air_end_time))
            || (airTime && vodTime && nowDt > new Date(airTime.air_end_time) && nowDt < new Date(vodTime.air_start_time))
        )
            return []
        let buttons: ActionButtonProps[] = [];

        const isLinear = contentItem.video_types.includes("linear");
        const canResume = (airTime && nowDt - new Date(airTime.air_start_time) > 2*60*1000 && !isLinear) || (!airTime && !isLinear);
        const onAir = (airTime !== undefined && nowDt >= new Date(airTime.air_start_time) && nowDt < new Date(airTime.air_end_time)) || isLinear;
        const record = canResume ? getHistoryRecord(contentItem.id) : null;
        const isVod = airTime === undefined && vodTime === undefined && !isLinear;

        if (record){
            buttons.push({
                label: `Resume ${formatDuration(record.position)}`,
                icon: 'icon-play',
                styleType: "white",
                spinner: true,
                onclick: () => {
                    if(acted)
                        return false
                    handleTrailerEnded()
                    store.playerScreen(record.position)
                        .catch(() => {
                            // console.log('error', err)
                            acted = false;
                        });
                    acted = true;
                    return acted;
                }
            } as ActionButtonProps)
            buttons.push({
                label: "Start Over",
                styleType: "optional",
                spinner: true,
                onclick: () => {
                    if(acted)
                        return false
                    handleTrailerEnded()
                    store.playerScreen(0)
                    // .catch((err) => {
                    //     // console.log('error', err)
                    //     acted = false;
                    // });
                    acted = true;
                    return acted
                }
            } as ActionButtonProps)
        }else if (isVod){
            buttons.push(
                {
                    label: "Play",
                    icon: 'icon-play',
                    styleType: "white",
                    spinner: true,
                    onclick: () => {
                        if(acted)
                            return false
                        handleTrailerEnded()
                        store.playerScreen(0);
                        acted = true;
                        return acted
                    }
                } as ActionButtonProps
            )
        }else if (!onAir){
            buttons.push(
                {
                    label: "Watch",
                    icon: buttons.length === 0 ? "icon-play" : "",
                    styleType: buttons.length === 0 ? "white" : "optional",
                    spinner: true,
                    onclick: () => {
                        if(acted)
                            return false
                        handleTrailerEnded()
                        store.playerScreen(0);
                        acted = true;
                        return acted
                    }
                } as ActionButtonProps
            )
        }

        if (!isVod && (!canResume || onAir)){
            buttons.push(
                {
                    label: "Watch Live",
                    icon: buttons.length === 0 ? "icon-play" : "",
                    styleType: buttons.length === 0 ? "white" : "optional",
                    spinner: true,
                    onclick: () => {
                        if(acted)
                            return false
                        handleTrailerEnded()
                        store.playerScreen(-1);
                        acted = true;
                        return acted
                    }
                } as ActionButtonProps
            )

            if (onAir && canResume && !record){
                buttons.push({
                    label: "Start Over",
                    styleType: "optional",
                    spinner: true,
                    onclick: () => {
                        if(acted)
                            return false
                        handleTrailerEnded()
                        store.playerScreen(0)
                        acted = true;
                        return acted
                    }
                } as ActionButtonProps)
            }
        }

        return buttons
    }else if(!contentItem.billing && !contentItem.tags.includes("authorized") && contentItem.video_types.includes("linear")){
        return [{
            label: "Watch Live",
            icon: 'icon-play',
            styleType: "white",
            spinner: true,
            onclick: () => {
                if(acted)
                    return false
                handleTrailerEnded()
                store.playerScreen(-1);
                // .catch((err) => {
                //     // console.log('error', err)
                //     acted = false;
                // });
                acted = true;
                return acted
            }
        } as ActionButtonProps]
    }else if(!contentItem.billing && !contentItem.tags.includes("authorized") && !contentItem.video_types.includes("linear")){
        return [{
            label: "Sign up to Watch",
            styleType: "primary",
            onclick: () => {
                window.location.href = `/account/signin/?return_to=${encodeURIComponent(window.location.href)}`
            }
        } as ActionButtonProps]
    }else if (contentItem.billing && contentItem.billing.price && !contentItem.billing.is_purchased && !contentItem.tags.includes("sold_out")){
        const price = formatPrice(contentItem.billing.price.amount, contentItem.billing.price?.currency)
        let hasPreview = false;
        let buttons = [];

        if (contentItem.tags.includes("has_vod_preview") && contentItem.tags.includes("replay") && !store.watchedPreview){
            hasPreview = true;
            if (contentItem.tags.includes("authorized")){
                buttons.push({
                    label: "Watch 10 min Free",
                    styleType: "primary",
                    onclick: () => {
                        store.previewScreen();
                    }
                } as ActionButtonProps)
            }else{
                buttons.push({
                    label: "Sign up to Watch",
                    styleType: "primary",
                    onclick: () => {
                        window.location.href = `/account/signin/?return_to=${encodeURIComponent(window.location.href)}`
                    }
                } as ActionButtonProps)
            }
        }

        if (!hasPreview || !contentItem.billing.has_purchase_options){
            if (contentItem.billing?.subscription){
                buttons.push({
                    label: `Watch with ${contentItem.billing.subscription}`,
                    styleType: !hasPreview ? "primary" : "optional",
                    onclick: () => {
                        if (!contentItem.links?.checkout){
                            return;
                        }
                        openWindow(contentItem.links.checkout.href, "purchase")
                        contentItem.addToCartEvent()
                    }
                } as ActionButtonProps)
            }else{
                let title = `Buy ${price}`
                if (contentItem.billing.required_subscription){
                    title = `${price} with ${contentItem.billing.required_subscription}`
                }
                buttons.push({
                    label: title,
                    styleType: !hasPreview ? "primary" : "optional",
                    onclick: () => {
                        if (!contentItem.links?.checkout){
                            return;
                        }
                        // console.log('open buy checkout', store.payment.checkout)
                        openWindow(contentItem.links.checkout.href, "purchase")
                        contentItem.addToCartEvent()
                    }
                } as ActionButtonProps)
            }
        }

        if (contentItem.billing.has_purchase_options && contentItem.links?.purchase_options?.href){
            buttons.push({
                label: "Purchase Options",
                styleType: "optional",
                onclick: () => {
                    if (!contentItem.links?.purchase_options){
                        return;
                    }
                    // console.log("open options", store.payment.options)
                    openWindow(contentItem.links.purchase_options.href, "options")
                }
            } as ActionButtonProps)
        }

        return buttons
    }
    return []
})

function handleTrailerEnded(){
    trailerVisible.value = false
    trailerPause.value = false
}
function handleClickTrailer(){
    if (trailerVisible.value){
        onPauseTrailer()
    }else{
        trailerVisible.value = !trailerVisible.value
    }
}

function onRate(){
    emit('toggle', 'rate')
}

function onPauseTrailer(){
    trailerPause.value = !trailerPause.value
}

function onMute(){
    trailerMute.value = !trailerMute.value;
}

function onCountdownEnd(){
    if (!store.itemLoaded ||
        contentItem.tags.includes("restricted") ||
        contentItem.tags.includes("expired")
    ){
        return;
    }
    const nowDt = new Date()
    const airTime = contentItem.broadcasts?.filter(row => {
        return row.is_live === true
    }).pop()
    if ((!contentItem.billing && contentItem.tags.includes("authorized")) || contentItem.billing?.is_purchased){
        if(airTime && nowDt < new Date(airTime.air_start_time))
            return

        handleTrailerEnded()
        store.playerScreen(-1);
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!trailerVisible.value)
          ? (_openBlock(), _createBlock(PictureComponent, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(contentItem).trailer && trailerVisible.value)
          ? (_openBlock(), _createBlock(TrailerComponent, {
              key: 1,
              onTrailerEnded: handleTrailerEnded,
              paused: trailerPause.value,
              muted: trailerMute.value
            }, null, 8, ["paused", "muted"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_unref(contentItem).tags.includes('on_air') && !_unref(contentItem).video_types.includes('linear'))
            ? (_openBlock(), _createBlock(PillOnAir, { key: 0 }))
            : _createCommentVNode("", true),
          (countdownTo.value)
            ? (_openBlock(), _createBlock(CountdownComponent, {
                key: 1,
                "start-time": countdownTo.value,
                onEnded: onCountdownEnd
              }, null, 8, ["start-time"]))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(contentItem).title), 1),
          _createElementVNode("div", _hoisted_7, [
            (_unref(contentItem).broadcasts)
              ? (_openBlock(), _createElementBlock("time", _hoisted_8, _toDisplayString(startTimeStr.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_unref(store).itemLoaded)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (button) => {
                    return (_openBlock(), _createBlock(ActionButtonComponent, {
                      key: button.label,
                      label: button.label,
                      icon: button?.icon,
                      spinner: button?.spinner,
                      styleType: button.styleType,
                      onclick: button?.onclick
                    }, null, 8, ["label", "icon", "spinner", "styleType", "onclick"]))
                  }), 128)),
                  (_unref(contentItem).tags.includes('restricted'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Unfortunately this event is not available in your territory."))
                    : _createCommentVNode("", true),
                  (_unref(contentItem).tags.includes('purchased') && _unref(contentItem).tags.includes('upcoming'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Purchased"))
                    : _createCommentVNode("", true),
                  (_unref(contentItem).tags.includes('sold_out'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Sold out"))
                    : _createCommentVNode("", true),
                  (_unref(contentItem).tags.includes('expired'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Expired"))
                    : _createCommentVNode("", true),
                  (!_unref(contentItem).tags.includes('restricted') && _unref(contentItem).tags.includes('upcoming') && !_unref(contentItem).billing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Waiting to Start"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (_unref(store).itemLoaded && !_unref(contentItem).tags.includes('restricted') && _unref(contentItem).groupedMessages?.custom)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(contentItem).groupedMessages.custom, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text-h6m md:text-h6 font-bold",
                  key: message
                }, _toDisplayString(message), 1))
              }), 128))
            : _createCommentVNode("", true),
          (_unref(store).itemLoaded && _unref(contentItem).groupedMessages && _unref(contentItem).groupedMessages.replayInfo && !_unref(contentItem).tags.includes('restricted'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(contentItem).groupedMessages.replayInfo[0]), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            (_unref(store).itemLoaded)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(contentItem).trailer)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          class: "rounded-3xl text-mono-white bg-mono-ns-300 hover:bg-mono-ns-200 p-3.5 flex flex-row items-center gap-1 xl:gap-2",
                          onClick: handleClickTrailer
                        }, [
                          (trailerPause.value || !trailerVisible.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[0] || (_cache[0] = [
                                _createElementVNode("g", { "clip-path": "url(#clip0_5319_1454)" }, [
                                  _createElementVNode("path", {
                                    d: "M2.66666 12.1001V3.90007C2.66666 3.02674 3.39999 2.4334 4.07999 2.7534L12.6867 6.8534C13.5533 7.26674 13.5533 8.7334 12.6867 9.14674L4.07999 13.2467C3.39999 13.5734 2.66666 12.9734 2.66666 12.1001Z",
                                    fill: "currentColor"
                                  })
                                ], -1),
                                _createElementVNode("defs", null, [
                                  _createElementVNode("clipPath", { id: "clip0_5319_1454" }, [
                                    _createElementVNode("rect", {
                                      width: "10.6667",
                                      height: "10.6667",
                                      fill: "white",
                                      transform: "translate(2.66666 2.66666)"
                                    })
                                  ])
                                ], -1)
                              ])))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[1] || (_cache[1] = [
                                _createElementVNode("path", {
                                  d: "M5.3328 13.332C4.59954 13.332 3.9996 12.7321 3.9996 11.9988V3.99961C3.9996 3.26635 4.59954 2.66641 5.3328 2.66641C6.06606 2.66641 6.666 3.26635 6.666 3.99961V11.9988C6.666 12.7321 6.06606 13.332 5.3328 13.332Z",
                                  fill: "currentColor"
                                }, null, -1),
                                _createElementVNode("path", {
                                  d: "M10.6656 13.332C9.93234 13.332 9.3324 12.7321 9.3324 11.9988V3.99961C9.3324 3.26635 9.93234 2.66641 10.6656 2.66641C11.3989 2.66641 11.9988 3.26635 11.9988 3.99961V11.9988C11.9988 12.7321 11.3989 13.332 10.6656 13.332Z",
                                  fill: "currentColor"
                                }, null, -1)
                              ]))),
                          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Trailer", -1))
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: onMute,
                          class: "rounded-3xl text-mono-white bg-mono-ns-300 hover:bg-mono-ns-200 p-3.5 flex flex-row items-center gap-1 xl:gap-2"
                        }, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_19, [
                            (trailerMute.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[3] || (_cache[3] = _createElementVNode("path", {
                                    d: "M6.75001 7.75H3.85001C2.75001 7.75 1.85001 8.65 1.85001 9.75V14.35C1.85001 15.45 2.75001 16.35 3.85001 16.35H6.75001L11.85 20.05V4.05L6.75001 7.75Z",
                                    fill: "currentColor"
                                  }, null, -1)),
                                  _cache[4] || (_cache[4] = _createElementVNode("path", {
                                    d: "M22.15 9.35L20.65 7.95L17.95 10.75L15.15 7.95L13.75 9.35L16.55 12.15L13.75 14.85L15.15 16.35L17.95 13.55L20.65 16.35L22.15 14.85L19.35 12.15L22.15 9.35Z",
                                    fill: "currentColor"
                                  }, null, -1))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[5] || (_cache[5] = _createElementVNode("path", {
                                    d: "M4 7.7C2.9 7.7 2 8.6 2 9.7V14.3C2 15.4 2.9 16.3 4 16.3H6.9L12 20V4L6.9 7.7H4Z",
                                    fill: "currentColor"
                                  }, null, -1)),
                                  _cache[6] || (_cache[6] = _createElementVNode("path", {
                                    d: "M18 12C18 9.8 16.2 8 14 8V10C15.1 10 16 10.9 16 12C16 13.1 15.1 14 14 14V16C16.2 16 18 14.2 18 12Z",
                                    fill: "currentColor"
                                  }, null, -1)),
                                  _cache[7] || (_cache[7] = _createElementVNode("path", {
                                    d: "M14 4V6C17.3 6 20 8.7 20 12C20 15.3 17.3 18 14 18V20C18.4 20 22 16.4 22 12C22 7.6 18.4 4 14 4Z",
                                    fill: "currentColor"
                                  }, null, -1))
                                ], 64))
                          ]))
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "rounded-3xl text-mono-white bg-mono-ns-300 hover:bg-mono-ns-200 p-3.5 flex flex-row items-center gap-1 xl:gap-2",
                    onClick: onRate
                  }, [
                    _cache[8] || (_cache[8] = _createElementVNode("svg", {
                      class: "w-4",
                      viewBox: "0 0 16 16",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }, [
                      _createElementVNode("use", { "xlink:href": "#icon-rate" })
                    ], -1)),
                    (_unref(contentItem).rating_score)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(contentItem).rating_score.toFixed(1)), 1))
                      : _createCommentVNode("", true),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Rate", -1))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})